import { render, staticRenderFns } from "./PetPhotos.vue?vue&type=template&id=058ef874&scoped=true"
import script from "./PetPhotos.vue?vue&type=script&setup=true&lang=js"
export * from "./PetPhotos.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PetPhotos.vue?vue&type=style&index=0&id=058ef874&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058ef874",
  null
  
)

export default component.exports